import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { get_cdn_url, use_store } from "../store";
import Button from "./button";

interface UserNotFoundProps {
  username: string;
}

export default function UserNotFound({ username }: UserNotFoundProps) {
  const { t, set_account_analysis } = use_store();

  return (
    <div className="w-full max-w-[600px] mx-auto mt-[48px]">
      <div className="bg-surface rounded-[8px] border-[1px] border-lines p-[48px] flex flex-col items-center">
        <div className="rounded-full mb-[24px]">
          <img
            src={get_cdn_url("/not_found_3.webp")}
            className="h-[48px] w-[48px]"
          ></img>
        </div>
        <p className="bigt text-primary text-center mb-[32px]">
          {t("We couldn't find @{username}").replace("{username}", username)}
        </p>
        <p className="smallt mt-[0px] mb-[8px]">
          {t("Do you want to try another username?")}
        </p>
        <div className="w-[360px]">
          <Button
            onClick={() => {
              window.scrollTo(0, 0);
              set_account_analysis(undefined);
            }}
          >
            <FontAwesomeIcon
              icon={faSparkles}
              className="text-[18px] mr-[8px]"
            ></FontAwesomeIcon>
            {t("Search Again")}
          </Button>
        </div>
      </div>
    </div>
  );
}
